import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

export function useSettings() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/settings").then((r) => setData(r.data)).catch(() => {}); }, []);
  const save = async (patch) => {
    try {
      const { data: d } = await api.put("/settings", patch);
      setData(d);
      toast.success("Gespeichert");
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  return { data, setData, save };
}
